import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BondCalculatorComponent } from './bond-calculator.component';
import { BondCalculatorService } from './bond-calculator.service';
import { SettingsBoxComponent } from './settings-box/settings-box.component';
import { CalendarModule, TooltipModule } from 'primeng/primeng';
import { VwdPilldownModule } from '@vwd/vwd-pilldown';
import { CalcBoxComponent } from './calc-box/calc-box.component';
import { ResultBoxComponent } from './result-box/result-box.component';
import { InstrumentPillModule } from '../../assets/shared/component/instrument-pill';
import { TranslateModule } from '@ngx-translate/core';
import { I18nPipesModule } from '@vwd/ngx-i18n/pipes';
import { I18nFormsModule } from '@vwd/ngx-i18n/forms';
import { OnlyNumberModule } from '../../assets/shared/directive/only-number';

@NgModule({
  declarations: [
    BondCalculatorComponent,
    SettingsBoxComponent,
    CalcBoxComponent,
    ResultBoxComponent
  ],
  imports: [
    CommonModule,
    CalendarModule,
    TooltipModule,
    VwdPilldownModule,
    InstrumentPillModule,
    TranslateModule,
    I18nPipesModule,
    I18nFormsModule,
    OnlyNumberModule
  ],
  providers: [
    BondCalculatorService
  ],
  exports: [
    BondCalculatorComponent,
  ],
})
export class BondCalculatorModule { }
